import React, { useEffect } from 'react';
import { ThemeProvider } from 'next-themes';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { EstimatorProvider } from './context/EstimatorContext';
import { ContentProvider } from './context/ContentContext';
import { captureUTM, fetchPublicSettings, injectAnalytics } from './lib/site';
import Landing from './pages/Landing';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  useEffect(() => {
    captureUTM();
    fetchPublicSettings().then(injectAnalytics);
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem><div className="App">
      <BrowserRouter>
        <ContentProvider>
          <EstimatorProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </EstimatorProvider>
        </ContentProvider>
      </BrowserRouter>
      <Toaster position="top-right" visibleToasts={3} closeButton />
    </div></ThemeProvider>
  );
}

export default App;
